import US from './US.json';
import UK from './UK.json';

export default {
  US,
  UK,
};
